import { TasksDatatable } from "datatables/tasks"
export default class TasksIndex extends ApplicationController {
  connect () {
    this.datatable = new TasksDatatable()
  }
}